import { Box, styled } from "@mui/material";

export const StyledAddArt = styled(Box)(({ theme }) => ({
  width: "80%",
  ".imageWrapper": {
    display: "flex",
    gap: "1rem",
    width: "100%",
    maxWidth: "100%",
    overflowX: "scroll",
    paddingBlock: "1rem",
    flexShrink: "0",
    justifyContent: "center",
    ".addimageBtn": {
      minWidth: "20rem",
      minHeight: "100%",
      height: "10rem",
      background: theme.contrast.lighter,
      color: theme.color.dark,
      "&:hover": {
        background: theme.color.contrastColor,
        color: theme.color.background,
      },
    },
    ".image": {
      minWidth: "20rem",
      height: "10rem",
      position: "relative",
      border: `4px solid ${theme.color.background}`,
      cursor: "pointer",
      borderRadius: "10px",
      overflow: "hidden",
      img: {
        width: "100%",
        height: "100%",
        objectFit: "cover",
      },
      svg: {
        position: "absolute",
        right: ".5rem",
        top: ".5rem",
        color: theme.color.contrastColor,
        background: theme.color.background,
        padding: ".5rem",
        borderRadius: "5px",
        cursor: "pointer",
        "&:hover": {
          color: theme.color.background,
          background: theme.color.contrastColor,
          transition: ".5s",
        },
      },
    },
    ".selected": {
      border: `4px solid ${theme.color.contrastColor}`,
    },
  },
  ".artForm": {
    ".row": {
      display: "flex",
      gap: "1rem",
      alignItems: "center",
      justifyContent: "center",
      ".column": {
        width: "100%",
        h3: {
          fontWeight: "bold",
        },
      },
    },
    ".pageButton": {
      display: "flex",
      gap: "1rem",
      h3: {
        fontWeight: "bold",
      },
    },
    ".savebtn": {
        width: "100%",
        fontSize: "1.5rem"
    }
  },
}));
